import { UserModel, UserResponse } from '@aionzdev/modules';
import { Usuario } from '../models/usuario';

export function mapUsuarioToUserModel(user: Usuario): UserModel {
  return {
    id: String(user.id),
    name: user.nome,
    userName: user.email,
    email: user.email,
    cpf: user.cpf,
    phone: user.telefone1,
    avatar: user.avatar,
    isDeleted: false,
    tenantId: user.accountId,
    createdAt: new Date(),
    updatedAt: new Date(),
    userAttributes: [{ key: 'bio', value: user.bio ?? '', label: 'Biografia' }],
  };
}

export function mapUserResponseToUserModel(user: UserResponse): UserModel {
  return {
    id: user.id,
    name: user.name,
    userName: user.userName,
    email: user.email,
    cpf: user.cpf,
    phone: user.phone,
    avatar: user.avatar,
    isDeleted: user.isDeleted,
    tenantId: user.tenantId,
    createdAt: user.createdAt,
    updatedAt: user.updatedAt,
    userAttributes: user.userAttributes,
  };
}
